import { Injector } from '@angular/core';
import { SideViewResizeControls } from '../render/controls/side-view-resize-controls';
import { rotateCuboid } from '../state/cuboid-location-state-3d';
import { ensureKeyLocation } from '../utils/point-cloud-interpolation-helper';
import { AbstractSideViewDragHandler } from './abstract-side-view-drag-handler';

export class SideViewRotateCuboidDragHandler extends AbstractSideViewDragHandler {
  protected method = 'rotate_side_panel_shape';

  constructor(
    initialEvent: MouseEvent,
    controls: SideViewResizeControls,
    injector: Injector,
  ) {
    super(controls, initialEvent, injector);
  }

  protected onDrag(event: MouseEvent) {
    const radian = this.getRadian(event);
    this.rotateFocusedMesh(radian);
  }

  private rotateFocusedMesh(radian: number) {
    const frameNumber = this.store.state().render.frameNumber;
    const focusedShapeStore = this.getFocusedShapeStore();

    const locationStore = ensureKeyLocation(
      focusedShapeStore('key_locations'),
      frameNumber,
    );
    const location = locationStore.state();

    const newLocation = {
      ...location,
      rotation: rotateCuboid(location.rotation, this.controls.axis, radian),
    };

    locationStore.set(newLocation);
  }

  private getRadian(event: MouseEvent) {
    // This is set to give the same rotation experience in all side views
    // When movementX is positive, rotate counter-clockwise
    // The -/+ value relates to the direction of the horizontal axis
    // in the orthographic camera relative to the clientX axis
    const counterClockwiseDirection = [-1, 1, 1];
    const movementX = this.getCanvasDelta(event)[0];
    const movement = movementX * counterClockwiseDirection[this.controls.axis];

    const rotationSpeed = 1e-2;
    const radian = movement * rotationSpeed;

    return radian;
  }
}
